import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { ConfigService } from "@core/config/app.config.service";
import { DatosBasicos, RepresentanteLegal } from "@shared/interfaces/app.state.interfaces";
import { Observable } from "rxjs";
import { GeneralResponse } from "../seguridad/seguridad.service";

@Injectable({
    providedIn: 'root'
})
export class EmpleadorService {

    constructor(
        private readonly _http: HttpClient,
        private readonly _configService: ConfigService
    ) { }

    private get urlActualizarClienteFocunEmpleador(): string {
        return `${this._configService.config.apiUrls.urlGatewayProcesos}/empleador/actualizar-cliente-focun`;
    }

    private get urlActualizarEstadosEmpleador(): string {
        return `${this._configService.config.apiUrls.urlGatewayProcesos}/empleador/actualizar-estados`;
    }

    private get urlConsultarEstadosEmpleador(): string {
        return `${this._configService.config.apiUrls.urlGatewayProcesos}/empleador/consultar-estados`;
    }

    private get urlActualizarEmpleador(): string {
        return `${this._configService.config.apiUrls.urlGatewayProcesos}/empleador/actualizar`;
    }

    private get urlActualizarCrearSucursales(): string {
        return `${this._configService.config.apiUrls.urlGatewayProcesos}/empleador/actualizar-crear-sucursales`;
    }

    public actualizarIdClienteFocunEmpleador(idEmpleador: number, idClienteFocun: number): Observable<GeneralResponse<any>> {
        const body = {
            id_empleador: idEmpleador,
            id_cliente_focun: idClienteFocun
        }
        return this._http.put<GeneralResponse<any>>(`${this.urlActualizarClienteFocunEmpleador}`, body);
    }

    public actualizarEstadoFocunEmpleador(idEmpleador: number, estados: Object): Observable<GeneralResponse<any>> {
        const body = {
            id_empleador: idEmpleador,
            estados_afiliacion: estados
        }
        return this._http.put<GeneralResponse<any>>(`${this.urlActualizarEstadosEmpleador}`, body);
    }
    public consultarEstadoFocunEmpleador(idEmpleador: number): Observable<GeneralResponse<any>> {
        return this._http.get<GeneralResponse<any>>(`${this.urlConsultarEstadosEmpleador}/${idEmpleador}`);
    }

    public actualizarEmpleador(request: { datosBasicos: DatosBasicos, representanteLegal: RepresentanteLegal }): Observable<GeneralResponse<{ datosBasicos, representanteLegal }>> {
        return this._http.put<GeneralResponse<{ datosBasicos, representanteLegal }>>(`${this.urlActualizarEmpleador}`, request);
    }

    public actualizarCrearSucursales(sucursales): Observable<GeneralResponse<any>> {
        return this._http.put<GeneralResponse<any>>(`${this.urlActualizarCrearSucursales}`, sucursales);
    }
}
